<template>
  <root-account-nav>
    <div v-if="hasPromotions()" class="promotions">
      <a :href="`/mx/${this.$snippet('promotions-api', 'promotions')}`">
        <base-snippet name="heartland-promotions-text">
          Promotions!
        </base-snippet>
      </a>
    </div>
  </root-account-nav>
</template>

<script>
  import {testTokenScope} from "^/IxPlugin/api"
  import RootAccountNav from "^/top-level/account-nav"
  import BaseSnippet from "^/base/_base-snippet"

  export default {
    name: "account-nav",
    components: {
      BaseSnippet,
      RootAccountNav,
    },
    methods: {
      hasPromotions() {
        return testTokenScope('price.read')
      }
    }
  }
</script>

<style scoped>
  #header .top-menu-area .promotions{
    text-align: center;
  }
  #header .top-menu-area .promotions a {
    color:#CC242A;
    color: var(--secondary-lighter);
    text-transform: uppercase;
    font-size: 1.2em;
  }
  #header .top-menu-area .promotions a:hover,
  #header .top-menu-area .promotions a:visited{
    color:#CC242A;
    color: var(--secondary-lighter);
  }
</style>


// WEBPACK FOOTER //
// ixcms/themes/heartlandtan/src/vue-src/top-level/account-nav.vue